import React, { Component } from 'react';
import { Button, Drawer, Select } from 'antd';

import {
  FilterOutlined,
  DeleteOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { getPoiGroupsAction } from '../../../actions/AppCms/PoiGroupActions';
import { getObjectNumListAction } from '../../../actions/SpecActions/ObjectNumActions';
import { getCmsLanguagesAction } from '../../../actions/AppCms/CmsLanguageActions';

const { Option } = Select;

class POIListDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterParams: {
        groupId: null,
        itemId: null,
        language: null,
      },
    };
  }

  componentDidMount = () => {
    const { getPoiGroupsAction: getPoiGroupsAction1 } = this.props;
    getPoiGroupsAction1();
    const { getObjectNumListAction: getObjectNumListAction1 } = this.props;
    getObjectNumListAction1();
    const { getCmsLanguagesAction: getCmsLanguagesAction1 } = this.props;
    getCmsLanguagesAction1();
  };

  handleChangeGroup = value => {
    const { filterParams } = this.state;
    this.setState({
      filterParams: {
        ...filterParams,
        groupId: value,
      },
    });
  };

  handleChangeItem = value => {
    const { filterParams } = this.state;
    this.setState({
      filterParams: {
        ...filterParams,
        itemId: value,
      },
    });
  };

  handleChangeLanguage = value => {
    const { filterParams } = this.state;
    this.setState({
      filterParams: {
        ...filterParams,
        language: value,
      },
    });
  };

  handleOnClose = () => {
    const { form, parentOnClose } = this.props;
    form.resetFields();
    parentOnClose();
  };

  handleOnSearch = () => {
    const { form, parentOnClose, handleFilterParams } = this.props;
    const { filterParams } = this.state;
    
    handleFilterParams(filterParams);
    form.resetFields();
    parentOnClose();
  };

  handleOnClear = () => {
    const { form, parentOnClose, handleResetFilters } = this.props;
    const { filterParams } = this.state;
    
    this.setState(
      {
        filterParams: {
          groupId: null,
          itemId: null,
          language: null,
        },
      },
      () => {
        // eslint-disable-next-line react/destructuring-assignment
        // handleFilterParams(this.state.filterParams);
        handleResetFilters();
      },
    );
    form.resetFields();
    parentOnClose();
  };

  render() {
    const {
      form,
      visible,
      filterParams,
      poiGroups,
      objectNumList,
      cmsLanguageList,
      defaultLanguage,
    } = this.props;
    const { getFieldDecorator } = form;
    return (
      (<Drawer
        title={
          <div>
            <FilterOutlined /> Filters{' '}
          </div>
        }
        placement="right"
        width={350}
        closable
        onClose={this.handleOnClose}
        open={visible}
      >
        <Form onSubmit={this.handleSubmit} layout="vertical">
          <Form.Item label="Language">
            {getFieldDecorator('language', {
              rules: [],
              initialValue:
                filterParams && filterParams.language
                  ? filterParams.language
                  : defaultLanguage,
            })(
              <Select
                allowClear
                showSearch
                filterOption
                optionFilterProp="children"
                onChange={this.handleChangeLanguage}
              >
                {cmsLanguageList.map(item => (
                  <Option key={item.id} value={item.isoLanguage.code}>
                    {item.isoLanguage.title}
                  </Option>
                ))}
              </Select>,
            )}
          </Form.Item>
          <Form.Item label="POI Group">
            {getFieldDecorator('groupId', {
              rules: [],
              initialValue:
                filterParams && filterParams.groupId
                  ? filterParams.groupId
                  : undefined,
            })(
              <Select
                allowClear
                showSearch
                filterOption
                optionFilterProp="children"
                onChange={this.handleChangeGroup}
              >
                {poiGroups.map(item => (
                  <Option key={item.id} value={item.id}>
                    {item.title}
                  </Option>
                ))}
              </Select>,
            )}
          </Form.Item>
          <Form.Item label="Linked Item">
            {getFieldDecorator('itemId', {
              rules: [],
              initialValue:
                filterParams && filterParams.itemId
                  ? filterParams.itemId
                  : undefined,
            })(
              <Select
                allowClear
                showSearch
                filterOption
                optionFilterProp="children"
                onChange={this.handleChangeItem}
              >
                {objectNumList.map(item => (
                  <Option key={item.id} value={item.id}>
                    {item.objectName}
                  </Option>
                ))}
              </Select>,
            )}
          </Form.Item>
        </Form>
        <div
          style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
          }}
        >
          <Button
            type="danger"
            onClick={this.handleOnClear}
            style={{ marginRight: 8 }}
          >
            <DeleteOutlined /> Clear
          </Button>
          <Button onClick={this.handleOnSearch} type="primary">
            <SearchOutlined /> Search
          </Button>
        </div>
      </Drawer>)
    );
  }
}

POIListDrawer.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object,
  visible: PropTypes.bool,
  parentOnClose: PropTypes.func,
  handleFilterParams: PropTypes.func,
  filterParams: PropTypes.object,
  handleResetFilters: PropTypes.func,
  poiGroups: PropTypes.array,
  getPoiGroupsAction: PropTypes.func,
  getObjectNumListAction: PropTypes.func,
  objectNumList: PropTypes.array,
  getCmsLanguagesAction: PropTypes.func,
  cmsLanguageList: PropTypes.array,
  defaultLanguage: PropTypes.string,
};

function mapStateToProps({
  poiGroupReducer,
  objectNumReducer,
  cmsLanguageReducer,
}) {
  const { poiGroups } = poiGroupReducer;
  const { objectNumList } = objectNumReducer;
  const { cmsLanguageList } = cmsLanguageReducer;

  return {
    poiGroups,
    objectNumList,
    cmsLanguageList,
  };
}

const WrappedDrawer = Form.create({ name: 'POIListDrawer' })(POIListDrawer);

const WrappedPOIListDrawer = connect(mapStateToProps, {
  getPoiGroupsAction,
  getObjectNumListAction,
  getCmsLanguagesAction,
})(WrappedDrawer);
export default WrappedPOIListDrawer;
